module.exports = __webpack_public_path__ + "static/RegisterNewAccount-5b1fc8a7a365e5a355a92f932131eb34.png";